var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_vm._v(" 首页介绍 "),_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.gotoLogin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }